import React from "react";
import { Card, Button, Tag, Space, Typography, Divider } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { formatAddress } from "../utils";
import AddressLetter from "../../AddressLetter";

const { Text, Title } = Typography;

const AdressCard = ({
  address,
  isOldAddress,
  onPrintClick,
  printStatus,
  unPrintClick,
  email,
  isGuestDetails,
}) => {
  const title = isOldAddress ? "From:" : "To:";

  return (
    <Card title={title} style={{ flex: 1, minWidth: 300 }}>
      <Text style={{ display: "block", marginBottom: 16 }}>{formatAddress(address)}</Text>
      <Divider />
      <div style={{ textAlign: "center" }}>
        {printStatus && (
          <Tag color="green" style={{ marginBottom: 12 }}>
            This document has already been printed.
          </Tag>
        )}
        <div>
          {printStatus ? (
            <Button onClick={unPrintClick} danger>
              Mark as Not Printed
            </Button>
          ) : (
            <div onClick={onPrintClick}>
              <AddressLetter
                button={
                  <Button icon={<PrinterOutlined />} type="primary" ghost>
                    Print
                  </Button>
                }
                address={formatAddress(address)}
                name={email}
                {...(isGuestDetails && {
                  extraProp1: "value1",
                  extraProp2: "value2",
                })}
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default AdressCard;
